import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import rodadas from "./modules/rodadas";
import * as offline from "@/plugins/offline";

export default new Vuex.Store({
  state: {
    produtos: JSON.parse(localStorage.getItem("carrinho")) || [],
    rodada: JSON.parse(localStorage.getItem("rodada")) || {},
    categorias: [],
    filtro: {
      termoPesquisa: "",
      categorias: [],
      filtrarValores: false,
      valorInicial: 0,
      valorFinal: 0,
      fornecedor: null,
    },
    count_notificacoes: null,
    rodadaVirtualStatus: false,
    rodadaVirtualData: null,
    rodadaSetada: false,
    impressoes: JSON.parse(localStorage.getItem("impressoes")) || [],
    impressoes_count: localStorage.getItem("impressoes_count") || 0,
    pedidosOnline: [],
    pedidosOffline: [],
    sincronizando: false,
    showImprimirPdf: false,
    pdfLoading:
      "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgogIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAwIDAiIHhtbDpzcGFjZT0icHJlc2VydmUiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiCiAgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiIHN0eWxlPSJiYWNrZ3JvdW5kOiBzaWx2ZXIiPgogIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik03Myw1MGMwLTEyLjctMTAuMy0yMy0yMy0yM1MyNywzNy4zLDI3LDUwIE0zMC45LDUwYzAtMTAuNSw4LjUtMTkuMSwxOS4xLTE5LjFTNjkuMSwzOS41LDY5LjEsNTAiPgogICAgPGFuaW1hdGVUcmFuc2Zvcm0gYXR0cmlidXRlTmFtZT0idHJhbnNmb3JtIiBhdHRyaWJ1dGVUeXBlPSJYTUwiIHR5cGU9InJvdGF0ZSIgZHVyPSIxcyIgZnJvbT0iMCA1MCA1MCIgdG89IjM2MCA1MCA1MCIKICAgICAgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIC8+CiAgPC9wYXRoPgo8L3N2Zz4=",
    // "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCiAgdmlld0JveD0iMCAwIDEwMCAxMDAiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDAgMCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgc3R5bGU9ImJhY2tncm91bmQ6IHNpbHZlciI+CiAgPGNpcmNsZSBmaWxsPSIjZmZmIiBzdHJva2U9Im5vbmUiIGN4PSIxNiUiIGN5PSI1MCIgcj0iNiI+CiAgICA8YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJvcGFjaXR5IiBkdXI9IjFzIiB2YWx1ZXM9IjA7MTswIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgYmVnaW49IjAuMSIgLz4KICA8L2NpcmNsZT4KICA8Y2lyY2xlIGZpbGw9IiNmZmYiIHN0cm9rZT0ibm9uZSIgY3g9IjUwJSIgY3k9IjUwIiByPSI2Ij4KICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9Im9wYWNpdHkiIGR1cj0iMXMiIHZhbHVlcz0iMDsxOzAiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiBiZWdpbj0iMC4yIiAvPgogIDwvY2lyY2xlPgogIDxjaXJjbGUgZmlsbD0iI2ZmZiIgc3Ryb2tlPSJub25lIiBjeD0iODMlIiBjeT0iNTAiIHI9IjYiPgogICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0ib3BhY2l0eSIgZHVyPSIxcyIgdmFsdWVzPSIwOzE7MCIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIGJlZ2luPSIwLjMiIC8+CiAgPC9jaXJjbGU+Cjwvc3ZnPg==",
    pdfUrl: null,
    // "https://manning-content.s3.amazonaws.com/download/5/54dea42-e46e-44c7-a930-d4c86a2c2ca3/CORS_ch03.pdf",
  },
  getters: {
    pedidos(state) {
      const lista = [].concat(state.pedidosOnline);
      state.pedidosOffline.forEach((p) => {
        const pedidoIdx = lista.findIndex((ped) => p.uuid === ped.uuid);
        if (pedidoIdx >= 0) {
          lista[pedidoIdx] = { ...p };
        } else {
          lista.unshift(p);
        }
      });

      return lista;
    },
    sincronizando(state) {
      return state.sincronizando;
    },
  },
  mutations: {
    showImprimirPdf(state, value) {
      state.showImprimirPdf = value;
      state.pdfUrl = !value ? state.pdfUrl : null;
    },
    adicionarItemCarrinho(state, produto) {
      const carrinho = JSON.parse(localStorage.getItem("carrinho")) || [];
      carrinho.unshift(produto);
      localStorage.setItem("carrinho", JSON.stringify(carrinho));
      state.produtos = carrinho;
    },
    removerItemCarrinho(state, index) {
      state.produtos.splice(index, 1);
      localStorage.setItem("carrinho", JSON.stringify(state.produtos));
    },
    setFiltro(state, filtro) {
      state.filtro = { ...state.filtro, ...filtro };
    },
    setRodada(state, rodada) {
      state.rodada = rodada;
      if (rodada.id) {
        state.rodadaSetada = true;
        localStorage.setItem("rodada", JSON.stringify(rodada));
      } else {
        state.rodadaSetada = false;
        localStorage.removeItem("rodada");
      }
    },
    setCategorias(state, categorias) {
      state.categorias = categorias;
    },
    setCountNotificacoes(state, count) {
      state.count_notificacoes = count;
    },
    setRodadaVirtual(state, params) {
      state.rodadaVirtualStatus = params.status;
      state.rodadaVirtualData = params;
    },
    setFlagRodada(state, bool) {
      state.rodadaSetada = bool;
    },
    setNovaImpressao(state, impressao) {
      state.impressoes.unshift(impressao);
      localStorage.setItem("impressoes", JSON.stringify(state.impressoes));
      state.impressoes_count++;
      localStorage.setItem("impressoes_count", state.impressoes_count);
    },
    zerarImpressoes(state) {
      localStorage.removeItem("impressoes");
      localStorage.removeItem("impressoes_count");
      state.impressoes_count = 0;
      state.impressoes = [];
    },
    marcarImpressaoLida(state, impressao_id) {
      let index = state.impressoes.findIndex((impressao) => {
        return impressao.impressao_id == impressao_id;
      });

      if (index > -1) {
        state.impressoes.splice(index, 1);
        state.impressoes_count--;
        localStorage.setItem("impressoes", JSON.stringify(state.impressoes));
        localStorage.setItem("impressoes_count", state.impressoes_count);
      }
    },
    setPedidos(state, pedidos) {
      state.pedidosOnline = pedidos;
    },
    setPedidosOffline(state, pedidosOffline) {
      state.pedidosOffline = pedidosOffline;
    },
    setSincronizando(state, value) {
      state.sincronizando = value;
    },
    setPedidoOk(state, { uuid, id }) {
      const pedido = state.pedidosOffline.find((ped) => ped.uuid === uuid);
      if (id) {
        state.pedidosOnline = [
          {
            ...pedido,
            id,
            offline: false,
            status: 1,
          },
        ].concat(state.pedidosOnline);
      } else {
        state.pedidosOnline = state.pedidosOnline.map((ped) =>
          ped.uuid === uuid ? { ...pedido, offline: false, status: 1 } : ped
        );
      }
      state.pedidosOffline = state.pedidosOffline.filter(
        (ped) => ped.uuid !== uuid
      );
    },
    setPdfUrl(state, pdf) {
      const url = URL.createObjectURL(
        new Blob([pdf], {
          type: "application/pdf",
        })
      );
      state.pdfUrl = url;
    },
  },
  actions: {
    sincronizar({ state, commit, dispatch }) {
      // if (!localStorage.getItem("offLine")) {
      //   setTimeout(() => dispatch("sincronizar"), 10000);
      //   return;
      // }

      if (!state.sincronizando) {
        commit("setSincronizando", true);
        Promise.all(
          state.pedidosOffline.map(
            (pedido) =>
              new Promise((resolve, reject) => {
                offline.loadPedidoFromCache(pedido.uuid).then((ped) => {
                  if (ped.data.pedido.id) {
                    offline
                      .atualizar(ped.data.pedido)
                      .then(() => {
                        commit("setPedidoOk", { uuid: ped.data.pedido.uuid });
                        resolve();
                      })
                      .catch(() => reject());
                  } else {
                    offline
                      .salvar(ped.data.pedido)
                      .then(({ data }) => {
                        commit("setPedidoOk", {
                          uuid: ped.data.pedido.uuid,
                          id: data.id,
                        });
                        resolve();
                      })
                      .catch(() => reject());
                  }
                });
              })
          )
        )
          .then(() => {
            commit("setSincronizando", false);
            setTimeout(() => dispatch("sincronizar"), 10000);
          })
          .catch(() => {
            commit("setSincronizando", false);
            setTimeout(() => dispatch("sincronizar"), 10000);
          });
      }
    },
    loadPedidosFromCache({ state, commit }) {
      // if (!localStorage.getItem("offLine")) return Promise.resolve();

      return offline.loadPedidosFromCache().then((result) => {
        const pedidosOffline = state.rodada.id
          ? result.filter((p) => p.rodada_id === state.rodada.id)
          : result;

        commit("setPedidosOffline", pedidosOffline);
      });
    },
  },
  modules: {
    rodadas,
  },
});
